import { render, staticRenderFns } from "./QcOrderDetail.vue?vue&type=template&id=5a05cfeb&scoped=true&"
import script from "./QcOrderDetail.ts?vue&type=script&lang=js&"
export * from "./QcOrderDetail.ts?vue&type=script&lang=js&"
import style0 from "./QcOrderDetail.vue?vue&type=style&index=0&id=5a05cfeb&prod&scoped=true&lang=css&"
import style1 from "./QcOrderDetail.vue?vue&type=style&index=1&id=5a05cfeb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a05cfeb",
  null
  
)

export default component.exports